import { gql } from '@apollo/client';

import { PREVIEW_RENDERER_VERSION_FILE_FRAGMENT } from '@/components/PreviewRenderer/PreviewRendererFragment';

export const USERS_BY_IDS_FOR_AI_SEARCH = gql`
  query SearchAIResults_UsersByIds($input: UsersByIdsInput!) {
    usersByIdsForAiAsk(input: $input) {
      results {
        _id
        displayName
        jobTitle
        company
        firstName
        lastName
        preferredName
        prefix
        suffix
        nameTitle
        proxyProfilePictureUrl(
          input: { w: 140, h: 140, fit: "facearea", facepad: 10.0 }
        )
      }
    }
  }
`;

export const ORGANIZATIONS_BY_IDS_FOR_AI_SEARCH = gql`
  query SearchAIResults_OrganizationsByIds($organizationIds: [String!]!) {
    sponsorsByIds(input: { organizationIds: $organizationIds }) {
      results {
        _id
        name
        displayName
        dateCreated
        isSponsor
        aboutUs
        profilePicture {
          imageProxy(input: { w: 160, h: 160, fit: "fill" })
        }
        sponsorship {
          currentTier {
            name
          }
        }
      }
    }
  }
`;

export const POSTS_BY_IDS_FOR_AI_SEARCH = gql`
  query SearchAIResults_postsByIdsForAiAsk($input: PostsByIdsForAiAskInput!) {
    postsByIdsForAiAsk(input: $input) {
      results {
        _id
        title
        bodyPlainText
        datePublished
        reactionCount
        commentCount
        authorId
        author {
          _id
          displayName
          firstName
          lastName
          preferredName
          prefix
          suffix
          nameTitle
          proxyProfilePictureUrl(
            input: { w: 140, h: 140, fit: "facearea", facepad: 10.0 }
          )
        }
        group {
          _id
          name
        }
        organization {
          _id
          name
        }
        blog {
          _id
          title
          content
        }
        poll {
          _id
          title
          description
          responseCount
          descriptionContentState {
            blocks {
              text
            }
          }
        }
        question {
          _id
          title
          answerCount
          body
          bodyContentState {
            blocks {
              text
            }
          }
        }
        answer {
          _id
          questionId
          body
          bodyContentState {
            blocks {
              text
            }
          }
          question {
            _id
            title
          }
        }
      }
    }
  }
`;

export const EVENTS_BY_IDS_FOR_AI_SEARCH = gql`
  query SearchAIResults_EventsByIds($ids: [String!]!) {
    eventsByIds(input: { ids: $ids }) {
      results {
        __typename
        _id
        name
        shortDescription
        description
        startDate
        endDate
        timeZone
        status
        isCourseWorkshop
        isXproConferenceEvent
        xproEventBanner
        bannerImage {
          imageProxy(input: { w: 320, h: 180, fit: "fill" })
        }
        ... on ConferenceEventV2 {
          venueType
        }
        ... on SimpleEventV2 {
          venue {
            type
          }
        }
      }
    }
  }
`;

export const VERSIONFILES_BY_IDS_FOR_AI_SEARCH = gql`
  query SearchAIResults_VersionFilesByIds(
    $input: VersionFilesByIdsForAiAskInput!
  ) {
    versionFilesByIdsForAiAsk(input: $input) {
      results {
        _id
        dateCreated
        file {
          _id
          name
          isVideo
          isImage
          url
          imageProxy(input: {})
        }
        author {
          _id
          displayName
          proxyProfilePictureUrl(
            input: { w: 40, h: 40, fit: "facearea", facepad: 10.0 }
          )
        }
        originalPost {
          _id
          title
          bodyPlainText
        }
        originalComment {
          _id
          postV2 {
            _id
          }
        }
      }
    }
  }
`;

export const VERSIONFILE_PREVIEW_FOR_AI_ASK = gql`
  query SearchAIResults_VersionFilePreview(
    $input: VersionFilesByIdsForAiAskInput!
  ) {
    versionFilesByIdsForAiAsk(input: $input) {
      results {
        ...PreviewRenderer_VersionFileFragment
      }
    }
  }
  ${PREVIEW_RENDERER_VERSION_FILE_FRAGMENT}
`;

export const GROUPS_BY_IDS_FOR_AI_SEARCH = gql`
  query SearchAIResults_GroupsByIds($input: GroupsByIdsInput!) {
    groupsByIds(input: $input) {
      results {
        _id
        name
        description
        totalMembers
        profileImage {
          imageProxy(input: { w: 80, h: 80, fit: "fill" })
        }
      }
    }
  }
`;

export const TAGS_BY_IDS_FOR_AI_SEARCH = gql`
  query SearchAIResults_TagsByIds($input: TagsByIdsInput!) {
    tagsByIds(input: $input) {
      results {
        _id
        name
      }
    }
  }
`;
